import { Injectable } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { NgxPermissionsService } from 'ngx-permissions';
import { BehaviorSubject, filter, take } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private permissionsLoadedSubject = new BehaviorSubject<boolean>(false);
  public permissionsLoaded$ = this.permissionsLoadedSubject.asObservable();

  constructor(
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private permissionsService: NgxPermissionsService,
  ) { }

  public waitForMsalReady(): Promise<void> {
    return new Promise((resolve) => {
      this.msalBroadcastService.inProgress$
        .pipe(
          filter((status: InteractionStatus) => status === InteractionStatus.None),
          take(1)
        )
        .subscribe(() => {
          resolve();
        });
    });
  }

  public isAuthenticated(): boolean {
    return this.msalService.instance.getAllAccounts().length > 0;
  }

  public getUser() {
    return this.msalService.instance.getAllAccounts()[0];
  }

  public setActiveAccount() {
    this.msalService.instance.setActiveAccount(this.msalService.instance.getAllAccounts()[0]);
  }

  public getActiveAccount() {
    return this.msalService.instance.getActiveAccount();
  }

  public getUserEmail() {
    const account = this.msalService.instance.getAllAccounts()[0];
    const userEmail = account.idTokenClaims?.preferred_username || '';
    return userEmail;
  }

  public login(): void {
    this.msalService.loginRedirect({ scopes: environment.msalConfig.loginScope });
  }

  public logout(): void {
    this.msalService.logout();
    localStorage.clear();
  }

  public logoutRedirect(): void {
    const account = this.getActiveAccount();
    this.msalService.logoutRedirect({ account: account, postLogoutRedirectUri: environment.msalConfig.auth.postLogoutRedirectUri });

  }

  public loadPermissionsFromStorage(): void {
    const permissionJson = localStorage.getItem('userPermission');
    if (permissionJson) {
      this.permissionsService.loadPermissions(JSON.parse(permissionJson));
    }
  }

  public hasAcceptedTerms(): Promise<boolean> {
    const loggedInUserJson = localStorage.getItem("loggedInUser");
    if (!loggedInUserJson) return Promise.resolve(false);

    const loggedInUser = JSON.parse(loggedInUserJson);
    return Promise.resolve(!!loggedInUser?.isAcceptedTC);
  }

  public isUserInfoAvailableInLocalStorage(): boolean {
    const loggedInUserJson = localStorage.getItem("loggedInUser");
    const permissionJson = localStorage.getItem('userPermission');
    return !!(loggedInUserJson && permissionJson);
  }

  public setPermissionsLoaded(loaded: boolean) {
    this.permissionsLoadedSubject.next(loaded);
  }

}
